"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.to-string");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'weChatAdList',
  components: {},
  data: function data() {
    return {
      list: [],
      listLoading: true,
      business_type: this.$route.query.business_type || '',
      business_des: '',
      adType: {
        1: 'Banner广告',
        2: '激励视频广告',
        3: '插屏广告',
        4: '视频广告',
        5: '视频前贴广告',
        6: '封面广告',
        7: '原生模板广告'
      },
      adDialog: false,
      form: {},
      clickSubmit: false
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      var url = 'agentapi/ad/get_wx_ad_positions_detail';
      this.$get(url, {
        business_type: this.business_type
      }).then(function (res) {
        _this.listLoading = false;
        _this.list = res.list;
        _this.business_des = res.business_des;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    /**
     * 显示dialog
     */
    setDialog: function setDialog() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        ad_type: 1
      };
      this.row = row;
      this.adDialog = true;
      var obj = (0, _defineProperty2.default)({
        business_type: row.business_type || this.business_type,
        position_type: row.position_type,
        ad_des: row.ad_des,
        ad_type: row.ad_type.toString()
      }, "ad_des", row.ad_des);
      this.form = obj;
    },
    /**
     * 提交编辑广告位置
     */
    postAdd: function postAdd(row) {
      var _this2 = this;
      var params = this.form;
      this.clickSubmit = true;
      this.$post('agentapi/ad/save_wx_ad_positions', params).then(function (res) {
        _this2.$message({
          message: '提交成功',
          type: 'success'
        });
        _this2.getList();
        _this2.adDialog = false;
        _this2.clickSubmit = false;
      });
    },
    /**
     * 设置是否显示
     */
    setShow: function setShow(row) {
      var _this3 = this;
      var is_show = row.is_show == 1 ? 0 : 1;
      this.$post('agentapi/ad/save_wx_ad_positions_detail_permission', {
        position_id: row.position_id,
        is_show: is_show
      }).then(function (res) {
        _this3.$message({
          message: '设置成功',
          type: 'success'
        });
        row.is_show = is_show;
      });
    },
    /**
     * 设置广告ID
     */
    adUnitId: function adUnitId(row) {
      var _this4 = this;
      this.$prompt("\u8BF7\u8F93\u5165\u5FAE\u4FE1".concat(this.adType[row.ad_type], "\u4F4DID"), '设置微信广告ID', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'text',
        inputValue: row.wx_ad_id,
        beforeClose: function beforeClose(action, instance, done) {
          if (action == 'confirm') {
            var value = instance.inputValue;
            _this4.$post('agentapi/ad/save_wx_ad_positions_detail_permission', {
              position_id: row.position_id,
              wx_ad_id: value.trim()
            }).then(function (res) {
              _this4.$message({
                message: '设置成功',
                type: 'success'
              });
              row.wx_ad_id = value;
              done();
            });
          } else {
            done();
          }
        }
      });
    },
    /**
     * 删除广告位置
     */
    delAd: function delAd(row, index) {
      var _this5 = this;
      this.$alert('确定删除此广告位置吗？', '删除广告位置', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == 'confirm') {
            _this5.$post('agentapi/ad/del_wx_ad_positions', {
              position_id: row.position_id
            }).then(function (res) {
              _this5.$message({
                message: '删除成功',
                type: 'success'
              });
              _this5.list.splice(index, 1);
            });
          }
        }
      });
    }
  }
};